export const composeParseResult = ({ content, extra }) => ({
  content,
  extra,
});

export const composeParseFn =
  (fn) =>
  async (file, extra = {}) =>
    fn(file, extra);
